import { render } from "./Mainone.vue?vue&type=template&id=12fe6f4d&scoped=true"
import script from "./Mainone.vue?vue&type=script&lang=js"
export * from "./Mainone.vue?vue&type=script&lang=js"

import "./Mainone.vue?vue&type=style&index=0&id=12fe6f4d&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12fe6f4d"]])

export default __exports__